import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action, select, Store } from '@ngrx/store';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  LoadStoryblokGlobalContentFailure,
  LoadStoryblokGlobalContentSuccess,
  StoryblokGlobalContentActionTypes,
} from './storyblok-global-content.actions';
import { BuyerState } from '~app/modules/generic/store';
import { StoryblokGlobalContentService } from '../../services/storyblok-global-content.service';
import { isStoryblokGlobalContentLoaded } from './storyblok-global-content.selectors';

@Injectable()
export class StoryblokGlobalContentEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<BuyerState>,
    private storyblokGlobalContentService: StoryblokGlobalContentService
  ) {}

  @Effect()
  loadStoryblokGlobalContent$: Observable<Action> = this.actions$.pipe(
    ofType(StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT),
    withLatestFrom(this.store$.pipe(select(isStoryblokGlobalContentLoaded)), (_, isLoaded: boolean) => isLoaded),
    filter((isLoaded) => !isLoaded),
    switchMap(() => {
      return this.storyblokGlobalContentService.getGlobalContent().pipe(
        map((globalContent) => new LoadStoryblokGlobalContentSuccess(globalContent)),
        catchError((error) => of(new LoadStoryblokGlobalContentFailure(error.message)))
      );
    })
  );
}
